import {WebhookService} from '../../libs/ui/src';
import {client} from '../apiService';

const _WebhookService = new WebhookService({client});
export {_WebhookService as WebhookService};
